import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Onboarding } from '@bciti/types';
import { ToastrService } from 'ngx-toastr';
import { of, Subject } from 'rxjs';
import { catchError, takeUntil, tap } from 'rxjs/operators';
import { OnboardingFormComponent } from 'src/app/components/forms/onboarding-form/onboarding-form.component';
import { OnboardingService } from 'src/app/services/onboarding/onboarding.service';

@Component({
    selector: 'app-onboarding-create-dialog',
    templateUrl: './onboarding-create-dialog.component.html',
    styleUrls: ['./onboarding-create-dialog.component.scss'],
})
export class OnboardingCreateDialogComponent implements OnInit, OnDestroy {
    destroy$ = new Subject();
    loading = false;

    @ViewChild(OnboardingFormComponent)
    private formVC: OnboardingFormComponent;

    constructor(private onboardingService: OnboardingService, private dialogRef: MatDialogRef<OnboardingCreateDialogComponent>, private toast: ToastrService) {}

    ngOnInit(): void {}

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    close(onboarding?: Onboarding) {
        this.dialogRef.close(onboarding);
    }

    submit() {
        this.formVC.submit();
    }

    createOnboarding(onboarding: Onboarding) {
        console.log('createOnboarding', onboarding);
        this.loading = true;
        this.onboardingService
            .createOnboarding(onboarding)
            .pipe(
                takeUntil(this.destroy$),
                tap((res) => this.toast.success(`Onboarding <b>${res.organisation.tag} was created`, 'Success', { enableHtml: true })),
                tap(() => (this.loading = false)),
                tap((res) => this.close(res)),
                catchError((error) => {
                    this.toast.error('An error occured. View browser console for details', 'Error');
                    console.log('error', error);
                    this.loading = false;
                    return of();
                }),
            )
            .subscribe();
    }
}
